/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { Icon, ICON_SIZE } from "../Icon";

export interface IBreadcrumbsSeparatorProps {
	separatorSize?: ICON_SIZE;
	className?: string;
}

export const BreadcrumbsSeparator: React.FC<IBreadcrumbsSeparatorProps> =
	React.memo<IBreadcrumbsSeparatorProps>(({ className, separatorSize }) => {
		const baseClass = BEM("edt-breadcrumbs", "list-item-separator");

		if (className) {
			baseClass.add(className);
		}

		return (
			<li aria-hidden className={`${baseClass.toClassName()}`}>
				<Icon name="mdi/menu-right" size={separatorSize} showLoader={false} />
			</li>
		);
	});

BreadcrumbsSeparator.displayName = "BreadcrumbsSeparator";

BreadcrumbsSeparator.defaultProps = {
	separatorSize: ICON_SIZE.SMALL
};
